"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapFacetFilterValuesToFacetQuery = void 0;
/**
 * Transforms the facets data from the FacetFilter component into a format suitable for the API query.
 *
 * @param facets - An array of FacetFilterValues, each representing a facet filter category with its label, key, and items.
 * Each item represents a filter option with its label, selection state, value, and type.
 * @returns An array of EditorialPlpRowsFacetFilter, each representing a facet filter with its name and keys.
 * Each key represents a selected filter option.
 *
 * Note: Only the selected filter options are included in the keys of the returned facet filters.
 * Also, the returned array does not include any facet filters that have no selected options.
 */ const mapFacetFilterValuesToFacetQuery = function(facets) {
    let onlySelected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _facets_map_filter;
    return (_facets_map_filter = facets === null || facets === void 0 ? void 0 : facets.map((facet)=>({
            name: facet.key,
            keys: onlySelected ? facet.items.filter((item)=>item.selected).map((item)=>item.value) : facet.items.map((item)=>item.value)
        })).filter((facet)=>facet.keys.length > 0)) !== null && _facets_map_filter !== void 0 ? _facets_map_filter : [];
};
exports.mapFacetFilterValuesToFacetQuery = mapFacetFilterValuesToFacetQuery;
